const validators = {
  email: {
    email: {
      message: "^errors.login.invalid_email"
    }
  },
  f_name: {
    length: {
      minimum: 2,
      message: "^errors.register.invalid_first_name"
    }
  },
  l_name: {
    length: {
      minimum: 2,
      message: "^errors.register.invalid_last_name"
    }
  },
  description: {
    length: {
      minimum: 1,
      message: "^errors.update_user_details.description"
    }
  },
  confirm_password: {
    equality: {
      attribute: "pw",
      message: "^errors.update_user_details.passwords_not_matching"
    }
  }
};

export default validators;
